module.exports = __webpack_public_path__ + "h5/img/child-nav3.430918c6.png";